/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, ReactNode, createContext, useContext } from "react";
import { NavLink } from "react-router-dom";

interface SidebarItemProps {
  icon: ReactNode;
  text: string;
  active: boolean;
  alert: any;
  href: string;
  dispatch: Dispatch<string>;
}
const SidebarContext = createContext<{
  expanded: boolean;
  open: boolean;
}>({ expanded: true, open: false });

function SidebarItem({
  icon,
  text,
  active,
  // alert,
  href,
  dispatch,
}: SidebarItemProps) {
  
  const { expanded, open } = useContext(SidebarContext);
  return (
    <NavLink
      to={href}
      onClick={() => dispatch("TOGGLE_MOBILE")}
      className={`h-14 relative flex items-center py-2 px-3 my-1 font-medium rounded cursor-pointer group z-[0] ${
        active
          ? "bg-gradient-to-tr from-secondary to-secondary text-white"
          : "hover:bg-secondary hover:text-white"
      }`}
    >
      <span>{icon}</span>
      <span
        className={`overflow-hidden transition-all text-sm ${
          expanded || open ? "ml-3 min-w-32" : "w-0"
        }`}
      >
        {text}
      </span>
    </NavLink>
  );
}

export { SidebarItem, SidebarContext };
